

import React, { useState, useEffect } from "react";
import Slidebar from "../Admin/Slidebar";
import { Outlet } from "react-router-dom";

const AdminLayout = ({admin}) => {

  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  useEffect(() => {

    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 992);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);

  }, []);

  return (
    <>
      <Slidebar admin={admin} />

      <div
        className="p-3"
        style={{
          marginLeft: isDesktop ? "240px" : "0px",
          overflowX: "hidden"
        }}
      >
        <Outlet />
      </div>
    </>
  );
};

export default AdminLayout;